import React from "react";
import styles from "./index.module.css"
import closeIcon from '../../../assets/images/icons/close-square.svg'

const CalendarEventUpdateForm = ({ register, handleSubmit, open, handleClose}) =>{

    return(
        <div className={open ? 'modal' : 'modal_hiden_bg'}>
            <div className={open ? 'modal_content' : 'modal_hiden'}>
                <div className={styles.modal_header}>
                    <h3 className={styles.modal_title}>Новое событие</h3>
                    <button onClick={handleClose} className={styles.modal_close}>
                        <img src={closeIcon} alt="closeIcon "/>
                    </button>
                </div>
                <div className={styles.modal_body}>
                    <form onSubmit={handleSubmit} className={styles.modal_form}>
                        <label className={styles.form_label}>
                            Дата
                            <input
                                {...register("date")}
                                className={styles.form_input}
                                type="date"
                                placeholder="ДД.ММ.ГГГГ"
                            />
                        </label>
                        <label className={styles.form_label}>
                            Время
                            <input
                                {...register("time")}
                                className={styles.form_input}
                                type="time"
                                placeholder="ДД.ММ.ГГГГ"
                            />
                        </label>
                        <label className={styles.form_label}>
                            Продолжительность
                            <select defaultValue="1" {...register("duration")} className={styles.form_select}>
                                <option value="1">1 ч.</option>
                                <option value="2">2 ч.</option>
                                <option value="3">3 ч.</option>
                                <option value="4">4 ч.</option>
                            </select>
                        </label>
                        <label className={styles.form_label}>
                            Комната
                            <select {...register("room")} className={styles.form_select}>
                                <option value="meeting room">Meeting room</option>
                                <option selected value="mini meeting room">Mini meeting room</option>
                            </select>
                        </label>
                        <label className={styles.form_label_max}>
                            Участники
                            <select
                                {...register("members")}
                                className={styles.form_select}
                            >
                                <option value="">--</option>
                                <option value="">--</option>
                            </select>
                        </label>
                        <label className={styles.form_label_max}>
                            Описание
                            <input
                                {...register("description")}
                                className={styles.form_input}
                                type="text"
                            />
                        </label>
                        <label className={styles.form_label}>
                            Отдел
                            <select
                                {...register("department")}
                                className={styles.form_select}
                            >
                                <option value="1">HR</option>
                                <option selected value="2">PHP</option>
                                <option value="3">Frontend</option>
                            </select>
                        </label>
                        <label className={styles.form_label}>
                            Ответственный
                            <input
                                {...register("responsible")}
                                className={styles.form_input}
                                type="text"
                            />
                        </label>
                        <label className={styles.form_label_max}>
                            Вид переговоров
                            <select {...register("type")} className={styles.form_select}>
                                <option value="">--</option>
                                <option value="">--</option>
                            </select>
                        </label>
                    </form>
                </div>
                <div className={styles.modal_footer}>
                    <button onClick={handleSubmit} type={"submit"} className={styles.save_btn}>Сохранить</button>
                    <button onClick={handleClose} className={styles.cancel_btn}>Отмена</button>
                </div>
            </div>
        </div>
    )
}
export default CalendarEventUpdateForm;
